import React, { Dispatch, SetStateAction, useState } from 'react'
import { reactSelectStyles, reactSelectTheme } from '../../utils/reactSelect'
import Select from 'react-select'
import { useQuery } from 'react-query'

import customerService from '../../services/customerService'
import placeService from '../../services/placeService'
import { useUser } from '../../hooks/useUser'

type AnalyticsFilterProps = {
  setCustomerId: Dispatch<SetStateAction<string | undefined>>
  setLocationId: Dispatch<SetStateAction<string | undefined>>
}

const AnalyticsFilter = (props: AnalyticsFilterProps) => {
  const user = useUser()

  const [customer, setCustomer] = useState<{ label: string; value: string } | null>(null)
  const [location, setLocation] = useState<{ label: string; value: string } | null>(null)

  const { data: customers, isLoading } = useQuery(['customers'], () => customerService.getAll({ search: '' }), {
    select: (data) => {
      return data.map(({ name, id }) => ({ label: name, value: id }))
    },
    enabled: user.data?.type === 'BUZZL',
  })

  const {
    data: places,
    isLoading: isPlacesLoading,
    isError: isPlacesError,
  } = useQuery(
    ['places', customer?.value],
    () => placeService.getAll({ where: { customer: { id: customer?.value } } }),
    {
      select: (data) => {
        return data.map(({ name, id }) => ({ label: name, value: id }))
      },
    }
  )

  if (user.isLoading || user.isError) {
    return null
  }

  return (
    <div className="flex w-full space-x-4">
      {user.data?.type === 'BUZZL' ? (
        <div className="w-full md:w-1/3">
          <label htmlFor="customer" className="mb-1 block text-sm font-medium text-gray-700">
            Select Customer
          </label>
          <Select
            id="customer"
            isDisabled={isLoading}
            isLoading={isLoading}
            placeholder="All"
            options={customers}
            styles={reactSelectStyles}
            theme={reactSelectTheme}
            value={customer}
            onChange={(newCustomer) => {
              const customer = newCustomer as { label: string; value: string }

              if (customer) {
                props.setCustomerId(customer.value)
                props.setLocationId(undefined)
                setCustomer(customer)
                setLocation(null)
              } else {
                props.setCustomerId(undefined)
                setCustomer(null)
              }
            }}
            isClearable
            isSearchable
          />
        </div>
      ) : null}

      <div className="w-full md:w-1/3">
        <label htmlFor="location" className="mb-1 block text-sm font-medium text-gray-700">
          Select Location
        </label>
        <Select
          id="location"
          isDisabled={isPlacesLoading}
          isLoading={isPlacesError}
          placeholder="All"
          options={places}
          styles={reactSelectStyles}
          theme={reactSelectTheme}
          value={location}
          onChange={(newLocation) => {
            const location = newLocation as { label: string; value: string }

            if (location) {
              props.setLocationId(location.value)
              setLocation(location)
            } else {
              props.setLocationId(undefined)
              setLocation(null)
            }
          }}
          isClearable
          isSearchable
        />
      </div>
    </div>
  )
}

export default AnalyticsFilter
